import { render, staticRenderFns } from "./guardian-data.vue?vue&type=template&id=952baaf0"
import script from "./guardian-data.ts?vue&type=script&lang=js&external"
export * from "./guardian-data.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports